import { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PageTitle from '../../../components/PageTitle'
import Loader from '../../../components/Loader'
import Empty from '../../../components/Empty'
import EventCard from './components/EventCard'
import Filters from './components/Filters'
import { getEvents } from '../../../actions/organizer'
import { formatRange } from '../../../utils/smallHelpers'


const Closed = () => {
  const dispatch = useDispatch()
  const events = useSelector((state) => state.organizer.events)
  const loading = useSelector((state) => state.organizer.loading)
  const [query, setQuery] = useState('')

  useEffect(() => {
    dispatch(getEvents({ active: false }))
  }, [dispatch])

  const items = useMemo(() => (events || []).map((e) => ({
    id: e.id,
    title: e.name,
    location: e.location || '',
    dates: formatRange(e.start_date, e.end_date),
    commission: (e.commission || []).map((c) => c.name_snapshot),
    hasResults: Boolean(e.has_results),
  })), [events])

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase()
    if (!q) return items
    return items.filter((event) =>
      event.title.toLowerCase().includes(q) ||
      event.location.toLowerCase().includes(q) ||
      event.commission.some((name) => name.toLowerCase().includes(q))
    )
  }, [items, query])

  return (
    <section>
      <PageTitle title="Завершенные мероприятия" />
      <Filters query={query} onQueryChange={setQuery} />
      {loading ? (
        <Loader size="lg" color="rgb(218 35 41)" />
      ) : filtered.length === 0 ? (
        <Empty />
      ) : (
        <div className="flex flex-col gap-[1.25rem]">
          {filtered.map((event) => (
            <EventCard key={event.id} {...event} />
          ))}
        </div>
      )}
    </section>
  )
}

export default Closed
